module.exports = __webpack_public_path__ + "img/deco-sprite-2x.7314471d.png";